<template>
  <NavButton
    v-if="enabled"
    v-b-tooltip.bottom.hover="tooltipTitle"
    :label="label"
    btn-id="filter-button"
    icon="filter"
    :image-src="imageSrc"
    :list="list"
    @click="click"
  />
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import NavButton from '@/components/public/NavButtons/NavButton.vue'
import { FILTER_BY_CATEGORY_KEY, SEARCH_CONFIG_KEY } from '@/constants'

const components = {
  NavButton,
}

const props = {
  list: Boolean,
}

@Component({ components })
export default class NavBtnFilterByCategory extends Vue.extend({ props }) {
  get enabled () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config[FILTER_BY_CATEGORY_KEY].enable
  }

  get label () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config[FILTER_BY_CATEGORY_KEY].buttonName
  }

  get imageSrc () {
    return this.$typedStore.activeVisualisation.visualisationStore.entities.images.imageOrPreview(['config', FILTER_BY_CATEGORY_KEY, 'buttonIcon'])
  }

  get enableSearchByLocation () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config[SEARCH_CONFIG_KEY].enableSearchByLocation
  }

  get filterByLocationActive () {
    const { currentLocation, filterRecords } = this.$typedStore.public.search
    return this.enableSearchByLocation && filterRecords && !this.$typedStore.activeVisualisation.visualisationStore.app.isEmpty(currentLocation)
  }

  get tooltipTitle () {
    return this.filterByLocationActive ? 'Cannot filter by category when search by location is active' : ''
  }

  click () {
    this.$bvModal.show('filter-by-category-modal')
  }
}

</script>
